export default "__VITE_ASSET__Cip9hdS8__"